import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import { i18n } from '@/i18n';

let projectController = new AbortController();
let isProjectsCalled = false;

export default {
  getProjects(params) {
    if (isProjectsCalled) {
      projectController.abort();
      projectController = new AbortController();
      isProjectsCalled = false;
    }
    isProjectsCalled = true;
    return axios
      .get(`/api/project`, {
        params,
        signal: projectController.signal
      })
      .then((res) => {
        isProjectsCalled = false;
        return res?.data;
      })
      .catch((err) => {
        isProjectsCalled = false;
        throw err;
      });
  },
  getSharedProjects(params) {
    if (isProjectsCalled) {
      projectController.abort();
      projectController = new AbortController();
      isProjectsCalled = false;
    }
    isProjectsCalled = true;
    return axios
      .get(`/api/project/shared`, {
        params,
        signal: projectController.signal
      })
      .then((res) => {
        isProjectsCalled = false;
        return res?.data;
      })
      .catch((err) => {
        isProjectsCalled = false;
        throw err;
      });
  },
  getPublicProjects(params) {
    if (isProjectsCalled) {
      projectController.abort();
      projectController = new AbortController();
      isProjectsCalled = false;
    }
    isProjectsCalled = true;
    return axios
      .get(`/api/project/public`, {
        params,
        signal: projectController.signal
      })
      .then((res) => {
        isProjectsCalled = false;
        return res?.data;
      })
      .catch((err) => {
        isProjectsCalled = false;
        throw err;
      });
  },
  starProject(alias, projectAlias, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/star`, params)
      .then((res) => {
        if (!params?.starred) {
          smallNotification('success', { title: i18n.t('message.addStarred') });
        } else {
          smallNotification('success', { title: i18n.t('message.removeStarred') });
        }
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  leaveProject(alias, projectAlias, data, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/leave`, data, {
        params,
        formName: FORM_NAME_ENUMS.LEAVE_PROJECT
      })
      .then((res) => {
        smallNotification('success', {
          title: i18n.t('message.projectLeave', { title: projectAlias })
        });
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  reportProject(alias, projectAlias, data, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/report`, data, {
        params,
        formName: FORM_NAME_ENUMS.REPORT_PROJECT
      })
      .then((res) => {
        smallNotification('success', { title: i18n.t('message.reportIsSent') });
        return res?.data;
      })
      .catch((err) => {
        throw err;
      });
  }
};
